<template>
  <div class="cargoWarehousingExceptionRecords">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.cargoWarehousing.exceptionHandling }}：
          <span v-if="item.ExceptionHandling == 1">{{
            $t.cargoWarehousing.eState1
          }}</span>
          <span v-if="item.ExceptionHandling == 2">{{
            $t.cargoWarehousing.eState2
          }}</span>
        </div>
        <div class="list-item">
          {{ $t.cargoWarehousing.consignee }}：{{ item.CurrentReceivingName }}
        </div>
        <div class="list-item">
          {{ $t.cargoWarehousing.consigneePhone }}：{{ item.CurrentlPhoneNumber }}
        </div>
        <div class="list-item">
          {{ $t.cargoWarehousing.consigneeAddress }}：{{ item.CurrentlReceivingAddress }}
        </div>
        <div class="list-item">
          {{ $t.cargoWarehousing.deliverer }}：{{ item.FullName }}
        </div>
        <div class="list-item">
          {{ $t.cargoWarehousing.username }}：{{ item.UserName }}
        </div>
        <div class="list-item">
          {{ $t.cargoWarehousing.createTime }}：{{ item.CreateTime }}
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { List } from "vant";
import Vue from "vue";
Vue.use(List);

export default {
  name: "cargoWarehousingExceptionRecords",
  data() {
    return {
      WB_Id: "",
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
    };
  },
  created() {
    const { WB_Id } = this.$route.query;
    this.WB_Id = WB_Id;
  },
  methods: {
    getList(page) {
      var param = {
        WB_Id: this.WB_Id,
        PageIndex: page,
        PageSize: this.pageSize,
      };
      this.$api.storage
        .getWaybillExceptionHandlingRecordListByPage(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cargoWarehousingExceptionRecords {
  .list-container {
    font-size: 12px;
    color: #333;
    padding: 10px;
    margin-top: 10px;
    box-shadow: 0px 2.5px 5px 2.5px rgba(0, 0, 0, 0.2);
    .list-item {
      margin-bottom: 10px;
    }
    .list-item:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
